import {
  PageBlueprint,
  createFrontendModule,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  CatalogFilterBlueprint,
  EntityCardBlueprint,
  EntityContentBlueprint,
  EntityHeaderBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import SecurityIcon from '@material-ui/icons/Security';
import { isComponent, isRuntimeComponent } from './model';
import { securityRouteRef } from './routes';

const governanceCard = EntityCardBlueprint.make({
  name: 'clrslate-component-governance',
  params: {
    filter: isComponent,
    type: 'info',
    loader: async () => {
      const { GovernanceCard } = await import('./GovernanceCard');
      return <GovernanceCard />;
    },
  },
});

const provenanceHeader = EntityHeaderBlueprint.make({
  name: 'clrslate-component-provenance',
  params: {
    filter: isComponent,
    loader: async () => {
      const { ProvenanceHeader } = await import('./ProvenanceHeader');
      return <ProvenanceHeader />;
    },
  },
});

const governanceFilters = CatalogFilterBlueprint.make({
  name: 'clrslate-component-governance',
  params: {
    loader: async () => {
      const { GovernanceFilters } = await import('./GovernanceFilters');
      return <GovernanceFilters />;
    },
  },
});

const componentSecurityContent = EntityContentBlueprint.make({
  name: 'clrslate-component-security',
  params: {
    path: 'security',
    title: 'Security',
    group: 'operation',
    icon: <SecurityIcon />,
    filter: isRuntimeComponent,
    loader: async () => {
      const { SecurityEntityPage } = await import('./SecurityEntityPage');
      return <SecurityEntityPage />;
    },
  },
});

const securityPage = PageBlueprint.make({
  params: {
    path: '/security',
    routeRef: securityRouteRef,
    title: 'Security',
    icon: <SecurityIcon />,
    noHeader: true,
    loader: async () => {
      const { SecurityPage } = await import('./SecurityPage');
      return <SecurityPage />;
    },
  },
});

export const componentGovernanceModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    governanceCard,
    provenanceHeader,
    governanceFilters,
    componentSecurityContent,
  ],
});

export const componentGovernancePlugin = createFrontendPlugin({
  pluginId: 'component-governance',
  routes: { root: securityRouteRef },
  extensions: [securityPage],
});
